<template>
  <div class="funds-list page-box">
    <query-header
      ref="header"
      @toQuery="toQuery"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          :noDataText="$t('root.noData')"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              {{$t('Trade.orderNo')}}
            </vs-th>
            <vs-th>
              {{$t('User.reportComiType')}}
            </vs-th>
            <vs-th>
              {{$t('Billing_message')}}
            </vs-th>
            <vs-th>
              {{$t('User.reportCommiAmount')}}
            </vs-th>
            <vs-th>
              {{$t('Approval_Status')}}
            </vs-th>
            <vs-th>
              {{$t('root.time')}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td>
                {{tr.id}}
              </vs-td>

              <vs-td>
                {{getType(tr)}}
              </vs-td>
              <vs-td>
                {{getInfo(tr)}}
              </vs-td>
              <vs-td>
                {{'$'+ (tr.amount || 0)}}
              </vs-td>
              <vs-td>
              <span>
                {{getStatus(tr)}}
              </span>
              </vs-td>
              <vs-td>
                {{tr.createTime}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime,getIsMoreThreeMonth } from '@/utils/index';
// 表格字段需要重新调
import {changeTimestamp} from '@/utils/common';
import commissionInitData from "./commissionInitData";
import queryHeader from "@/components/agent/commissionManage/commissionOutRecord/queryHeader";
export default {
  name: "index",
  components: {
    queryHeader,
  },
  data() {
    return {
    }
  },
  mixins: [commissionInitData],
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/crm/reception/partner/commWithdraw';

      this.params = {
        pageNum: this.page,
        pageSize: this.size - 1,
        custId: this.userInfo.id,
      }
      let header = this.$refs.header;
      // 添加时间

      if(header.outType !== ''){
        this.params.type = header.outType;
      }
      if(header.status){
        this.params.chkStatus = header.status;
      }
      if(header.date && header.date.length){
        this.params.startTime = parseTime(header.date[0],'{y}-{m}-{d}');
        this.params.endTime = parseTime(header.date[1],'{y}-{m}-{d}');
      }
      return true;
    },

    getInfo(row){
      switch (row.type) {
        case 0:
          return row.mt4Account;
        case 7:
          return row.bankAccount;
        case 8:
          return row.bankAccount;
        case 9:
          return row.bankAccount;
      }
    },
    getType(row){
      switch (row.type) {
        case 0:
          return this.$t('User.reportComiType2');
        case 7:
          return this.$t('User.reportComiType1');
        case 8:
          return this.$t('The_commission_to_USDT');
        case 9:
          return this.$t('The_commission_to_OTC365');
      }
    },
    getStatus(item){
      return item.chkStatus == 6 ? this.$t('User.reportCommiStatus1') : item.chkStatus == 7 ? this.$t('User.reportCommiStatus2') : this.$t('User.reportCommiStatus3')
    },

    searchHandle(){
      this.page = 1;
      this.init();
    }
  },
}
</script>

<style lang="scss" scoped>
.search-input {
  &.symbol {
    margin-left: 10px;
  }
}
</style>
